<template>
    <div class="history-detail">

        <div class="loading-indicator">

        </div>

        <div class="detail-display">
            <ul class="list-group">
                <li class="list-group-item" v-for="item in detailData">
                    <div class="detail-card">
                        <h4>{{ item.dateDuration }}</h4>
                        <p>{{ item.message }}</p>
                        <ul class="list-group">
                            <li class="list-group-item dayoff-item container-fluid" v-for="dayoff in item.dayoff">
                                <div class="col-xs-3">{{dayoff.date}}</div>
                                <div class="col-xs-3">{{dayoff.duration}} 小時</div>
                                <div class="col-xs-6">{{convertDayoffType(dayoff.type)}}</div>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
export default {
    props: [
        'user-uuid',
        'start-at',
        'end-at',
    ],
    data() {
        return {
            detailData: [
            ]
        }
    },

    methods: {
        convertDayoffType: function(type) {
            let rtn = CONST.DAYOFF_TYPES.filter(item => item.value == type)
            if (rtn.length > 0) {
                return rtn[0].display
            }
            return "";
        }
    },


    watch: {
      startAt: function () {
        if (this.userUuid && this.startAt && this.endAt) {
          axios.get('/api/dayoff/user/' + this.userUuid + '/dayoff-history-detail?start_at=' + this.startAt + '&end_at=' + this.endAt)
            .then((response) => {
              this.detailData = response.data;
            })
          ;
        }
      }
    },

    mounted() {
    },
}
</script>

<style lang="scss" scoped>
.history-detail {
    margin-top: 15px;
}
.dayoff-item {
    border: 0px;
}
</style>
